import { render, staticRenderFns } from "./BulkAssetActioner.vue?vue&type=template&id=54c56142&"
import script from "./BulkAssetActioner.vue?vue&type=script&lang=js&"
export * from "./BulkAssetActioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports